import { Injectable } from '@angular/core';
//import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Platform } from '@ionic/angular';
import { Log, LogLevel } from '../log';
import { CommunityUser } from 'src/app/data/schema/community-user';
import { Community } from 'src/app/data/schema/community';

@Injectable()
export class BrowserHelper {

    // Keep a reference to tab used for opening preview
    private previewWindow: Window | null = null;
    static instance: BrowserHelper;

    constructor() { 
        BrowserHelper.instance = this;
    }

    openUrl(path, target = '_blank', options = 'enableViewportScale=yes,location=no') {
        Log.debug('=== Opening link from browser-helper.openUrl: ', path);


        // Add http:// if the url is missing it
        if ( 
            !path.startsWith('tel:') && 
            !path.startsWith('mailto:') && 
            !path.toLowerCase().startsWith('http') &&
            !path.startsWith('blob:')) {
            path = 'https://' + path;
        }

        // if (this.platform.is('capacitor')) {
        //     // If the file isn't local, then use the inapp browser
        //     return this.inAppBrowser.create(path, target, options);
        // } else {
            Log.debug('   open with: window.open(' + path + ', ' + target + ');');
            return window.open(path, target);
        // }
    }

    openUrlInSystem(path, target = '_blank') {
        Log.debug('=== Opening link in system: ', path);
        return window.open(path, target);
    }
    

    static staticOpenUrl(path, target = '_blank', options = 'enableViewportScale=yes,location=no') {
        Log.debug('=== Opening link from static browser-helper.openUrl: ', path);
        // Add http:// if the url is missing it
        if (!path.toLowerCase().startsWith('http')) {
            path = 'https://' + path;
        }

        Log.debug('   open with: window.open(' + path + ', ' + target + ');');
        return window.open(path, target);
    }

    static openInGoogleMaps(locationString: string) {
        BrowserHelper.staticOpenUrl(`https://www.google.com/maps/search/?api=1&query=${locationString}`);
    }

    static openInSameTab(url: string) {
        // If the window hasn't been opened before, or if it was closed
        if (!BrowserHelper.instance.previewWindow || BrowserHelper.instance.previewWindow.closed) {
            // Open a new window and save the reference
            BrowserHelper.instance.previewWindow = window.open('about:blank', 'PagePreview');
        }

        // Set the location of the window to the new URL
        if (BrowserHelper.instance.previewWindow) {
            BrowserHelper.instance.previewWindow.location.href = url;
        }

        // Focus the window to bring it to the front
        BrowserHelper.instance.previewWindow?.focus();
    }

    async previewPage(path?: string) {

        // if previewing a page we will use SSO to ensure the admin
        // is automatically logged into the website as admin.

        // to reduce calls to server, we will re-use the SSO token
        // for 5 minutes, then get a new one. So lets check local storage
        // first to see if we have a token and if it is still valid
        const previewTokenInfo = JSON.parse(localStorage.getItem('previewTokenInfo') ?? '{}');
        let ssoToken;
        if (previewTokenInfo['token'] && previewTokenInfo['expires'] > Date.now()) {
            ssoToken = previewTokenInfo['token'];
        } else {
            // regenerate the token
            ssoToken = await CommunityUser.getSSOToken();
            // save it
            localStorage.setItem('previewTokenInfo', JSON.stringify({ token: ssoToken, expires: Date.now() + 300000 }));
        }

        if (!path) {
            path = '';
        } else if (!path.startsWith('/')) {
            path = '/' + path;
        }

        // our urls will either look like:
        // https://localhost:8100/cbs/blah.cb.ca/auth/sso/1234/abc123
        // or
        // https:/blah.cb.ca/auth/sso/1234/abc123
        // if it's the former, we need to add the /cbs/blah.cb.ca part to the path
        // so that angular can route it properly
        const rootUrl = Community.activeCommunity.getFullSiteUrl();
        if (rootUrl.includes('/cbs/')) {
            path = `/cbs/${Community.activeCommunity.communityUrl}${path}`;
        }
        else if (path === '') {
            path += '/';
        }

        // now we have a token, lets build the path
        const url = `${rootUrl}/auth/sso/${ssoToken}/${String.toURLSafeBase64(path)}`

        // If the window hasn't been opened before, or if it was closed
        if (!this.previewWindow || this.previewWindow.closed) {
            // Open a new window and save the reference
            this.previewWindow = window.open('about:blank', 'PagePreview');
        }

        Log.debug('open preview at ' + url);

        // Set the location of the window to the new URL
        if (this.previewWindow) {
            this.previewWindow.location.href = url;
        }

        // Focus the window to bring it to the front
        this.previewWindow?.focus();
    }
}
